export default class StringUtils {
    static isWhiteSpace(value : string) : boolean {
        return value.replace(/\s/g, '').length === 0;
    }
}